export function zeroPadInt(n = 0, padding = 2) {
  return n.toString().padStart(padding, '0');
}
